module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBold.fc0cf9d.woff";